export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full h-screen min-h-[640px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/14ef41ef4210d5284b1a0c6fad03fc26.jpg"
          alt="貸別荘イメージ"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full text-center px-6">
        <p className="text-amber-300 text-sm tracking-[0.4em] uppercase font-light mb-4">
          Vacation Rental Solutions
        </p>
        <h1 className="text-white text-4xl lg:text-6xl xl:text-7xl font-light leading-tight mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
          贅沢な<span className="font-semibold">滞在体験</span>を<br />
          共につくる
        </h1>
        <p className="text-white/80 text-lg lg:text-xl font-light max-w-2xl mx-auto mb-10 leading-relaxed">
          貸別荘・民泊の企画から申請、管理、リフォームまで<br className="hidden md:block" />
          トータルサポートでオーナー様の夢を実現します
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={() => handleScroll('#business')}
            className="whitespace-nowrap px-8 py-4 bg-amber-600 text-white text-sm font-medium rounded-full hover:bg-amber-700 transition-all duration-300 cursor-pointer"
          >
            事業内容を見る
          </button>
          <button
            onClick={() => handleScroll('#contact')}
            className="whitespace-nowrap px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-sm font-medium rounded-full border border-white/40 hover:bg-white/20 transition-all duration-300 cursor-pointer"
          >
            お問い合わせ
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/60">
        <span className="text-xs tracking-widest">SCROLL</span>
        <div className="w-px h-10 bg-white/40 animate-pulse" />
      </div>
    </section>
  );
}
